import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure} from "@nextui-org/react";
import axios from "axios";
import { product_uri } from "../../../../utils/url";
import { toast } from "react-toastify";

export default function DeleteModal({data, callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);

  const call = () =>{
    callback();
  }

  const Sub = async()=>{
    setLoad(true);
    try{
        const res = await axios.post(product_uri+'/delete', {id: data});
        if(res.status === 200){
            toast.success("Амжилттай");
            call();
            onOpenChange(false)
            setLoad(false)
        }
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  return (
    <>
      <Button size='sm' onClick={onOpen} className="ml-2">Устгах</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Баталгаажуулах</ModalHeader>
              <ModalBody>
                Та барааг устгахдаа итгэлтэй байна уу ?
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onClick={onClose}>
                  Close
                </Button>
                {
                    load?
                    <Button className="bg-blue-300">
                        Баталгаажуулж байна ...
                    </Button>
                    :
                    <Button color="primary" onClick={Sub}>
                        Тийм
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
